import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type {
  UpdateCompTicketsPayload, AssignCompTicketsPayload, ResendCompTicketPayload, CheckinPayload,
} from '@sda/interfaces/reducer/tickets.reducer';
import type { RedeemTicketDto } from '@sda/functions/ticket/put-redeem-ticket.endpoint';
import type { Ticket } from '@sda/interfaces/ticket';
import type { FetchDataType } from '@sda/sdk/interfaces';

// LISTENERS
export const startFetchTicket = createAction<string>(`${Reducers.TICKETS}/startFetchTicket`); // This fetches an unowned ticket from the back-end
export const startFetchOwnedTickets = createAction<string>(`${Reducers.TICKETS}/startFetchOwnedTickets`);
export const unsubscribeOwnedTickets = createAction<string>(`${Reducers.TICKETS}/unsubscribeOwnedTickets`);
export const startFetchTicketDetails = createAction<string>(`${Reducers.TICKETS}/startFetchTicketDetails`); // This fetches an owned ticket
export const unsubscribeTicket = createAction<string>(`${Reducers.TICKETS}/unsubscribeTicket`);

export const startAssignCompTickets = createAction<AssignCompTicketsPayload>(`${Reducers.TICKETS}/startAssignCompTickets`);
export const startCheckInTicket = createAction<CheckinPayload>(`${Reducers.TICKETS}/startCheckInTicket`);
export const startCheckInReverse = createAction<CheckinPayload>(`${Reducers.TICKETS}/startCheckInReverse`);
export const startRedeemShowTicket = createAction<{ ticketId: string, values: RedeemTicketDto }>(`${Reducers.TICKETS}/startRedeemShowTicket`);
export const startResendCompTicket = createAction<ResendCompTicketPayload>(`${Reducers.TICKETS}/startResendCompTicket`);
export const startRevokeCompTickets = createAction<FetchDataType[]>(`${Reducers.TICKETS}/startRevokeCompTickets`);
export const startScanTicketQRCode = createAction<{ showId: string, url: string }>(`${Reducers.TICKETS}/startScanTicketQRCode`);
export const startTransferTickets = createAction<{ email: string, name: string, ticketId: string }>(`${Reducers.TICKETS}/startTransferTickets`);
export const startUpdateCompTickets = createAction<UpdateCompTicketsPayload>(`${Reducers.TICKETS}/startUpdateCompTickets`);

export const ticketAdapter = createEntityAdapter<Ticket & FetchDataType>();

const ticketsSlice = createSlice({
  initialState: ticketAdapter.getInitialState(),
  name: Reducers.TICKETS,
  reducers: {
    ...extractSharedActions(ticketAdapter),
    setTicket: ticketAdapter.setOne,
    setTickets: ticketAdapter.setMany,
  },
});

export const {
  removeMany: removeTickets, updateOne: updateTicket, upsertMany: upsertTickets, updateMany: updateTickets,
  setTicket, setTickets,
} = ticketsSlice.actions;

export default ticketsSlice.reducer;
